import React from 'react';
import LogoIcon from './LogoIcon';
import LogoText from './LogoText';

interface LogoProps {
  size?: 'sm' | 'md' | 'lg';
  className?: string;
}

const Logo: React.FC<LogoProps> = ({ size = 'md', className = '' }) => {
  return (
    <div className={`flex items-center ${className}`}>
      <LogoIcon size={size} />
      <LogoText size={size} />
    </div>
  );
};

export default Logo;